// Utility functions to detect device types

/**
 * Detects if the current device is a mobile device
 * @returns {boolean} true if the device is mobile, false otherwise
 */
export const isMobileDevice = () => {
  // Check for mobile user agent patterns
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Regular expression for mobile devices (iOS, Android, etc.)
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  
  // Check if user agent matches mobile pattern
  return mobileRegex.test(userAgent);
};

/**
 * Checks if the device width is in mobile range (typically under 768px)
 * @returns {boolean} true if the viewport width is in mobile range
 */
export const isMobileViewport = () => {
  return window.innerWidth < 768;
};

/**
 * Comprehensive check if using a mobile device (either by agent or viewport size)
 * @returns {boolean} true if mobile device detected
 */
export const isMobile = () => {
  return isMobileDevice() || isMobileViewport();
}; 